module.exports = __webpack_public_path__ + "static/img/qrcode.3cb555e.jpg";